import { useEffect, useMemo } from "react";
import "./DashBoard.css";
import { useState } from "react";
import { useRef } from "react";
import locationRed from "../../../assets/svg/locationRed.svg";
import historyClock from "../../../assets/svg/historyClock.svg";
import blueGate from "../../../assets/svg/blueGate.svg";
import greenDepartment from "../../../assets/svg/greenDepartment.svg";
import blueOrg from "../../../assets/svg/blueOrg.svg";
import greyPurpose from "../../../assets/svg/greyPurpose.svg";
import meetingPerson from "../../../assets/svg/yellowPerson.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "react-circular-progressbar/dist/styles.css";
import {
  getLiveCountApi,
  getHistoryCountApi,
  getEntryCountApi,
  getRegistrationCountApi,
  getLocationCountApi,
  getGateCountApi,
  getDepartmentCountApi,
  getOrganizationCountApi,
  getPurposeCountApi,
  getMeetingPersonCountApi,
} from "./dashboard-api";
import { Container } from "react-bootstrap";
import { useGlobal } from "../../../GlobalContext";

const VisitorDashboard = ({ interval = 10, widgets = [] }) => {
  let { dashboardToken } = useGlobal();
  if (process.env.REACT_APP_ENVIRONMENT === "development") {
    dashboardToken =
      "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vc2lnbmFnZS92MS9hcGkvZGV2aWNlLzY3IiwiaWF0IjoxNzY3MTM5MTk5LCJleHAiOjE3OTg2NzUxOTksIm5iZiI6MTc2NzEzOTE5OSwianRpIjoiTGtBTU5qdHhCanFxNFBhRSIsInN1YiI6IjY3IiwicHJ2IjoiYjkwZjcxZjJiMDQ2ZjM1NDJhMDI3ODEwODllYTc1NjY4ZmUzYWU2MyIsImF1dGhpZCI6MTIzMiwib3JnaWQiOjEwNSwidXNlcmlkIjoxMjMyLCJkYXRhYmFzZW5hbWUiOiJyYWd1cnIiLCJvcmdfY29kZSI6InJhZ3VyciIsInRpbWV6b25lIjoiIiwicm9sZWlkIjo0OTcsInBheW1lbnRfc3RhdHVzIjp0cnVlLCJhdXRob3JpdGllcyI6WyJST0xFX1VTRVIiXSwiZGV2aWNlSWQiOjY3LCJncm91cElkIjo1Miwic2lnbmFnZV9jb2RlIjoiIn0.VpzQxFgAA2lqyRoIrKp9kkOiAg6j1-k7sfYQj9VO-4A";
  }

  /*  let dashboardToken =
    "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vc2lnbmFnZS92MS9hcGkvZGV2aWNlLzY3IiwiaWF0IjoxNzY3MTM5MTk5LCJleHAiOjE3OTg2NzUxOTksIm5iZiI6MTc2NzEzOTE5OSwianRpIjoiTGtBTU5qdHhCanFxNFBhRSIsInN1YiI6IjY3IiwicHJ2IjoiYjkwZjcxZjJiMDQ2ZjM1NDJhMDI3ODEwODllYTc1NjY4ZmUzYWU2MyIsImF1dGhpZCI6MTIzMiwib3JnaWQiOjEwNSwidXNlcmlkIjoxMjMyLCJkYXRhYmFzZW5hbWUiOiJyYWd1cnIiLCJvcmdfY29kZSI6InJhZ3VyciIsInRpbWV6b25lIjoiIiwicm9sZWlkIjo0OTcsInBheW1lbnRfc3RhdHVzIjp0cnVlLCJhdXRob3JpdGllcyI6WyJST0xFX1VTRVIiXSwiZGV2aWNlSWQiOjY3LCJncm91cElkIjo1Miwic2lnbmFnZV9jb2RlIjoiIn0.VpzQxFgAA2lqyRoIrKp9kkOiAg6j1-k7sfYQj9VO-4A";
 */ const intervalRef = useRef(null);

  const callAllAPIs = () => {
    const apiMap = {
      "Live Count": getLiveCount,
      "History Count": getHistoryCount,
      "Entry Based": getEntryCount,
      "Registration Based": getRegistrationCount,
      "Location Based": getLocationCount,
      "Gate Based": getGateCount,
      "Department Based": getDepartmentCount,
      "Organization Based": getOrganizationCount,
      "Purpose Based": getPurposeCount,
      "Meeting Person Based": getMeetingCount,
    };

    widgets.forEach((widget) => {
      if (widget.status && apiMap[widget.name]) {
        apiMap[widget.name]();
      }
    });
  };

  useEffect(() => {
    // Initial API call
    callAllAPIs();

    // Setup interval
    intervalRef.current = setInterval(() => {
      callAllAPIs();
    }, interval * 1000); // convert seconds to ms

    // Cleanup on unmount
    return () => clearInterval(intervalRef.current);
  }, [interval]);

  const [orgCreateDate, setOrgCreateDate] = useState("");

  const [liveCount, setLiveCount] = useState({});
  const [historyCount, setHistoryCount] = useState({});
  const [entryCount, setEntryCount] = useState({});
  const [registerCount, setRegisterCount] = useState({});
  const [locationBased, setLocationBased] = useState([]);
  const [gateBased, setGateBased] = useState([]);
  const [departmentBased, setDepartmentBased] = useState([]);
  const [orgBased, setOrgBased] = useState([]);
  const [purposeBased, setPurposeBased] = useState([]);
  const [meetingPersonBased, setMeetingPersonBased] = useState([]);

  const [sortedWidgetList, setSortedWidgetList] = useState([]);
  useEffect(() => {
    setSortedWidgetList([...widgets].sort((a, b) => a.seq_no - b.seq_no));
  }, []);

  const getLiveCount = async () => {
    try {
      const response = await getLiveCountApi(dashboardToken);
      if (response.status === true) {
        setLiveCount(response.data ?? {});
        setOrgCreateDate(response.data?.from_date || "");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getHistoryCount = async () => {
    try {
      const response = await getHistoryCountApi(dashboardToken);
      if (response.status === true) {
        setHistoryCount(response.data ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getEntryCount = async () => {
    try {
      const response = await getEntryCountApi(dashboardToken);
      if (response.status === true) {
        setEntryCount(response.data ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getRegistrationCount = async () => {
    try {
      const response = await getRegistrationCountApi(dashboardToken);
      if (response.status === true) {
        setRegisterCount(response.data ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getLocationCount = async () => {
    try {
      const response = await getLocationCountApi(dashboardToken);
      if (response.status === true) {
        const data = response.data || [];

        const total = data.reduce((s, it) => s + (Number(it.count) || 0), 0);

        const updatedCount = data.map((item) => ({
          ...item,
          percent:
            total === 0 ? 0.0 : ((Number(item.count) || 0) / total) * 100.0,
        }));
        setLocationBased(updatedCount);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getGateCount = async () => {
    try {
      const response = await getGateCountApi(dashboardToken);
      if (response.status === true) {
        const data = response.data || [];

        const total = data.reduce((s, it) => s + (Number(it.count) || 0), 0);

        const updatedCount = data.map((item) => ({
          ...item,
          percent:
            total === 0 ? 0.0 : ((Number(item.count) || 0) / total) * 100.0,
        }));
        setGateBased(updatedCount);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getDepartmentCount = async () => {
    try {
      const response = await getDepartmentCountApi(dashboardToken);
      if (response.status === true) {
        const data = response.data || [];

        const total = data.reduce((s, it) => s + (Number(it.count) || 0), 0);

        const updatedCount = data.map((item) => ({
          ...item,
          percent:
            total === 0 ? 0.0 : ((Number(item.count) || 0) / total) * 100.0,
        }));
        setDepartmentBased(updatedCount);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getOrganizationCount = async () => {
    try {
      const response = await getOrganizationCountApi(dashboardToken);
      if (response.status === true) {
        const data = response.data || [];

        const total = data.reduce((s, it) => s + (Number(it.count) || 0), 0);

        const updatedCount = data.map((item) => ({
          ...item,
          percent:
            total === 0 ? 0.0 : ((Number(item.count) || 0) / total) * 100.0,
        }));
        setOrgBased(updatedCount);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getPurposeCount = async () => {
    try {
      const response = await getPurposeCountApi(dashboardToken);
      if (response.status === true) {
        const data = response.data || [];

        const total = data.reduce((s, it) => s + (Number(it.count) || 0), 0);

        const updatedCount = data.map((item) => ({
          ...item,
          percent:
            total === 0 ? 0.0 : ((Number(item.count) || 0) / total) * 100.0,
        }));
        setPurposeBased(updatedCount);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getMeetingCount = async () => {
    try {
      const response = await getMeetingPersonCountApi(dashboardToken);
      if (response.status === true) {
        const data = response.data || [];

        const total = data.reduce((s, it) => s + (Number(it.count) || 0), 0);

        const updatedCount = data.map((item) => ({
          ...item,
          percent:
            total === 0 ? 0.0 : ((Number(item.count) || 0) / total) * 100.0,
        }));
        setMeetingPersonBased(updatedCount);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  // autoplay swipers
  // location
  const [activeLocation, setActiveLocation] = useState(0);
  const paginationCountLocation = chunkArray(locationBased, 5).length ?? 0;
  const autoplayDelay = 10000;
  const swiperRefLocation = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveLocation((prev) => {
        const next = (prev + 1) % paginationCountLocation;
        // Move swiper slide
        if (swiperRefLocation.current) {
          swiperRefLocation.current.slideToLoop(next);
        }
        return next;
      });
    }, autoplayDelay);
    return () => clearInterval(interval);
  }, [paginationCountLocation]);
  // gate
  const [activeGate, setActiveGate] = useState(0);
  const paginationCountGate = chunkArray(gateBased, 5).length ?? 0;
  const swiperRefGate = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveGate((prev) => {
        console.log("prev", prev);
        const next = (prev + 1) % paginationCountGate;
        console.log("next", next);
        // Move swiper slide
        if (swiperRefGate.current) {
          swiperRefGate.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, [paginationCountGate]);

  // department
  const [activeDepartment, setActiveDepartment] = useState(0);
  const paginationCountDepartment = chunkArray(departmentBased, 5).length ?? 0;
  const swiperRefDepartment = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveDepartment((prev) => {
        const next = (prev + 1) % paginationCountDepartment;

        // Move swiper slide
        if (swiperRefDepartment.current) {
          swiperRefDepartment.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, [paginationCountDepartment]);

  // organization
  const [activeOrganization, setActiveOrganization] = useState(0);
  const paginationCountOrganization = chunkArray(orgBased, 5).length ?? 0;
  const swiperRefOrganization = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveOrganization((prev) => {
        const next = (prev + 1) % paginationCountOrganization;

        // Move swiper slide
        if (swiperRefOrganization.current) {
          swiperRefOrganization.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, [paginationCountOrganization]);

  // purpose
  const [activePurpose, setActivePurpose] = useState(0);
  const paginationCountPurpose = chunkArray(purposeBased, 5).length ?? 0;
  const swiperRefPurpose = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActivePurpose((prev) => {
        const next = (prev + 1) % paginationCountPurpose;

        // Move swiper slide
        if (swiperRefPurpose.current) {
          swiperRefPurpose.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, [paginationCountPurpose]);

  // meeting person
  const [activeMeetingPerson, setActiveMeetingPerson] = useState(0);
  const paginationCountMeetingPerson =
    chunkArray(meetingPersonBased, 5).length ?? 0;
  const swiperRefMeetingPerson = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveMeetingPerson((prev) => {
        const next = (prev + 1) % paginationCountMeetingPerson;

        // Move swiper slide
        if (swiperRefMeetingPerson.current) {
          swiperRefMeetingPerson.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, [paginationCountMeetingPerson]);

  const MAX_DOTS = 5;

  const getVisibleDots = (total, active) => {
    if (total <= MAX_DOTS) {
      return { start: 0, end: total };
    }

    let start = active - Math.floor(MAX_DOTS / 2);
    let end = start + MAX_DOTS;

    if (start < 0) {
      start = 0;
      end = MAX_DOTS;
    }

    if (end > total) {
      end = total;
      start = total - MAX_DOTS;
    }

    return { start, end };
  };

  const { start: startLocation, end: endLocation } = useMemo(
    () => getVisibleDots(paginationCountLocation, activeLocation),
    [paginationCountLocation, activeLocation]
  );

  const { start: startGate, end: endGate } = useMemo(
    () => getVisibleDots(paginationCountGate, activeGate),
    [paginationCountGate, activeGate]
  );

  const { start: startDepartment, end: endDepartment } = useMemo(
    () => getVisibleDots(paginationCountDepartment, activeDepartment),
    [paginationCountDepartment, activeDepartment]
  );

  const { start: startOrg, end: endOrg } = useMemo(
    () => getVisibleDots(paginationCountOrganization, activeOrganization),
    [paginationCountOrganization, activeOrganization]
  );

  const { start: startPurpose, end: endPurpose } = useMemo(
    () => getVisibleDots(paginationCountPurpose, activePurpose),
    [paginationCountPurpose, activePurpose]
  );

  const { start: startMeetingPerson, end: endMeetingPerson } = useMemo(
    () => getVisibleDots(paginationCountMeetingPerson, activeMeetingPerson),
    [paginationCountMeetingPerson, activeMeetingPerson]
  );
  const fontResize = (baseFont, percentage) => {
    const fontSize = baseFont * (1 + percentage / 100);
    return fontSize;
  };
  const customFontPercentage = (width, width_size) => {
    var fontPercentage = 0;
    if (width === "custom") {
      fontPercentage = width_size ?? 0;
    } else if (width === "large") {
      fontPercentage = 30;
    } else if (width === "medium") {
      fontPercentage = 0;
    } else if (width === "small") {
      fontPercentage = -20;
    }
    return fontPercentage;
  };
  const ProgressDots = ({
    paginationCount,
    start,
    end,
    activeIndex,
    autoplayDelay = 2500,
  }) => {
    // create full indices, then slice
    const indices = useMemo(
      () =>
        Array.from({ length: paginationCount }, (_, i) => i).slice(start, end),
      [paginationCount, start, end]
    );

    return (
      <div className="dotsContainer">
        {indices.map((realIndex) => {
          const isActive = realIndex === activeIndex;
          return (
            <div
              key={realIndex}
              className={`dot ${isActive ? "dot--active" : ""}`}
              style={{ width: isActive ? 28 : 8, height: 8 }} // keep only dynamic width inline
            >
              {isActive && (
                <div
                  className="dot__fill"
                  style={{ animationDuration: `${autoplayDelay}ms` }}
                  aria-hidden
                />
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const ProgressBarRow = ({
    name,
    count,
    percent,
    barColor,
    fontPercentage,
  }) => (
    <div className="d-flex justify-content-between rowItem px-2">
      <div
        className="rowItem__label break-anywhere"
        style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}
      >
        {name}
      </div>

      <div className="d-flex align-items-center">
        <div className="rowItem__bar">
          <div
            className="rowItem__barFill"
            style={{ width: `${percent}%`, backgroundColor: barColor }}
          />
        </div>

        <div
          className="rowItem__count"
          style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}
        >
          {count}
        </div>
      </div>
    </div>
  );

  const liveCountWidget = (fontPercentage) => {
    return (
      <div className="col-xl-3 mt-3">
        <div className="bg-white p-3 rounded-4 h-100">
          <div className="row">
            <div className="col-5 d-flex flex-column gap-1">
              <p
                className="m-0"
                style={{
                  color: "#0D283E",
                  fontSize: `${fontResize(15, fontPercentage)}px`,
                  fontWeight: "700",
                }}
              >
                GATE IN
              </p>
              <p
                className="m-0"
                style={{
                  color: "#0D283E",
                  fontSize: `${fontResize(44, fontPercentage)}px`,
                  fontWeight: "700",
                }}
              >
                {liveCount.gate_in ?? 0}
              </p>
              <div
                className="d-flex justify-content-center py-2 rounded-pill align-items-center gap-2"
                style={{ backgroundColor: "#FFEEEE" }}
              >
                <div
                  className="rounded-circle"
                  style={{
                    width: "10px",
                    height: "10px",
                    backgroundColor: "#FF4444",
                  }}
                ></div>
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(13, fontPercentage)}px`,
                    fontWeight: "500",
                  }}
                >
                  Live count
                </p>
              </div>
            </div>
            <div className="col-7">
              <div
                className="d-flex justify-content-between align-items-center p-3 rounded-3"
                style={{
                  backgroundColor: "#DAFFED",
                  height: "65px",
                }}
              >
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(12, fontPercentage)}px`,
                    fontWeight: "500",
                    color: "#00B15C",
                  }}
                >
                  Approved
                </p>
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(24, fontPercentage)}px`,
                    fontWeight: "600",
                    color: "#0D283E",
                  }}
                >
                  {liveCount.approved ?? 0}
                </p>
              </div>
              <div
                className="d-flex justify-content-between align-items-center p-3 rounded-3 mt-3"
                style={{
                  backgroundColor: "#FFF2E5",
                  height: "65px",
                }}
              >
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(12, fontPercentage)}px`,
                    fontWeight: "500",
                    color: "#FF7A00",
                  }}
                >
                  Queue
                </p>
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(24, fontPercentage)}px`,
                    fontWeight: "600",
                    color: "#0D283E",
                  }}
                >
                  {liveCount.queue ?? 0}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const historyCountWidget = (fontPercentage) => {
    return (
      <div className="col-xl-9 mt-3">
        <div className="bg-white p-3 rounded-4">
          <div style={{ borderRadius: 0, position: "relative" }}>
            {/* Top Header Band */}
            <div
              style={{
                backgroundColor: "#fdeee0",
                borderRadius: "14px 14px 0 0",
                padding: "18px 8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 0,
                gap: 3,
              }}
            >
              <img src={historyClock} alt="clock" />
              <h1
                className="m-0"
                style={{
                  fontSize: `${fontResize(14, fontPercentage)}px`,
                  fontWeight: 700,
                  color: "#0D283E",
                }}
              >
                HISTORY
              </h1>
            </div>

            {/* Line below Header */}
            <div
              style={{
                height: 1,
                backgroundColor: "#cbd5e1",
                position: "relative",
              }}
            >
              {/* vertical ticks — centered in each column */}
              {Object.keys(historyCount).map((_, i) => (
                <div
                  key={i}
                  style={{
                    position: "absolute",
                    left: `calc(${
                      (i + 0.5) *
                      (100 / (Object.keys(historyCount).length ?? 0))
                    }%)`,
                    transform: "translateX(-50%)",
                    top: 1,
                    width: 1,
                    height: 26,
                    backgroundColor: "#cbd5e1",
                  }}
                ></div>
              ))}
            </div>

            {/* Stats Grid */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: `repeat(${
                  Object.keys(historyCount).length ?? 0
                }, 1fr)`,
                gap: 0,
                marginTop: 32,
              }}
            >
              {Object.keys(historyCount).map((key, index) => (
                <div key={index} className="text-center pt-2 px-2">
                  <div
                    className="fw-bold text-uppercase mb-1"
                    style={{
                      fontSize: `${fontResize(13, fontPercentage)}px`,
                      color: "#0D283E",
                      fontWeight: "700",
                    }}
                  >
                    {key.replace(/_/g, " ").toUpperCase()}
                  </div>
                  <div
                    className="fw-bold"
                    style={{
                      fontSize: `${fontResize(24, fontPercentage)}px`,
                      color: "#0f172a",
                      fontWeight: "600",
                    }}
                  >
                    {historyCount[key] ?? 0}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const entryBasedWidget = (fontPercentage) => {
    return (
      <div className="col-xl-6 mt-3">
        <div className="bg-white p-3 rounded-4">
          <div className="row align-items-end">
            <p
              style={{
                color: "#0D283E",
                fontSize: `${fontResize(15, fontPercentage)}px`,
                fontWeight: "700",
              }}
            >
              ENTRY BASED
            </p>
            <div className="d-flex flex-column col-2">
              <p
                className="m-0"
                style={{
                  fontSize: `${fontResize(32, fontPercentage)}px`,
                  fontWeight: "600",
                  color: "#172B4D",
                }}
              >
                {entryCount.total ?? 0}
              </p>
              <p
                style={{
                  color: "#626F86",
                  fontSize: `${fontResize(12, fontPercentage)}px`,
                  fontWeight: "400",
                }}
              >
                Total entries
              </p>
            </div>
            <div className="col">
              <div
                className="p-3 rounded-4"
                style={{ backgroundColor: "#F6F6F6" }}
              >
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(13, fontPercentage)}px`,
                    fontWeight: "400",
                    color: "#172B4D",
                  }}
                >
                  QR based
                </p>
                <p
                  className="m-0"
                  style={{
                    color: "#172B4D",
                    fontSize: `${fontResize(20, fontPercentage)}px`,
                    fontWeight: "500",
                  }}
                >
                  {entryCount.qr_based ?? 0}
                </p>
              </div>
            </div>
            <div className="col">
              <div
                className="p-3 rounded-4"
                style={{ backgroundColor: "#F6F6F6" }}
              >
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(13, fontPercentage)}px`,
                    fontWeight: "400",
                    color: "#172B4D",
                  }}
                >
                  Manual
                </p>
                <p
                  className="m-0"
                  style={{
                    color: "#172B4D",
                    fontSize: `${fontResize(20, fontPercentage)}px`,
                    fontWeight: "500",
                  }}
                >
                  {entryCount.manual ?? 0}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const registrationBasedWidget = (fontPercentage) => {
    return (
      <div className="col-xl-6 mt-3">
        <div className="bg-white p-3 rounded-4">
          <div className="row align-items-end">
            <p
              style={{
                color: "#0D283E",
                fontSize: `${fontResize(15, fontPercentage)}px`,
                fontWeight: "700",
              }}
            >
              REGISTRATION BASED
            </p>
            <div className="d-flex flex-column col-2">
              <p
                className="m-0"
                style={{
                  fontSize: `${fontResize(32, fontPercentage)}px`,
                  fontWeight: "600",
                  color: "#172B4D",
                }}
              >
                {registerCount.total ?? 0}
              </p>
              <p
                style={{
                  color: "#626F86",
                  fontSize: `${fontResize(12, fontPercentage)}px`,
                  fontWeight: "400",
                }}
              >
                Total entries
              </p>
            </div>
            <div className="col">
              <div
                className="p-3 rounded-4"
                style={{ backgroundColor: "#F6F6F6" }}
              >
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(13, fontPercentage)}px`,
                    fontWeight: "400",
                    color: "#172B4D",
                  }}
                >
                  Pre registration
                </p>
                <p
                  className="m-0"
                  style={{
                    color: "#172B4D",
                    fontSize: `${fontResize(20, fontPercentage)}px`,
                    fontWeight: "500",
                  }}
                >
                  {registerCount.pre_reg ?? 0}
                </p>
              </div>
            </div>
            <div className="col">
              <div
                className="p-3 rounded-4"
                style={{ backgroundColor: "#F6F6F6" }}
              >
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(13, fontPercentage)}px`,
                    fontWeight: "400",
                    color: "#172B4D",
                  }}
                >
                  Direct Registration
                </p>
                <p
                  className="m-0"
                  style={{
                    color: "#172B4D",
                    fontSize: `${fontResize(20, fontPercentage)}px`,
                    fontWeight: "500",
                  }}
                >
                  {registerCount.direct_reg ?? 0}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const locationBasedWidget = (fontPercentage) => {
    return (
      <div className="col-xl-4 mt-3">
        <div className="bg-white rounded-4 p-3">
          <div className="row">
            <div className="col-10">
              <div className="d-flex align-items-center gap-3">
                <img
                  className="p-2 rounded-circle"
                  src={locationRed}
                  alt="location"
                  style={{ backgroundColor: "#FFEEEE" }}
                />
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(15, fontPercentage)}px`,
                    fontWeight: "700",
                  }}
                >
                  LOCATION BASED
                </p>
              </div>
            </div>

            <div className="col-2 d-flex justify-content-end">
              <ProgressDots
                paginationCount={paginationCountLocation}
                start={startLocation}
                end={endLocation}
                activeIndex={activeLocation}
                autoplayDelay={autoplayDelay}
              />

              {/* Animation keyframes */}
              <style>
                {`
        @keyframes progressFill {
          from { transform: scaleX(0); }
          to { transform: scaleX(1); }
        }
      `}
              </style>
            </div>

            {/* Progress Bars */}
            <Swiper
              onSwiper={(swiper) => (swiperRefLocation.current = swiper)}
              spaceBetween={12}
              breakpoints={{
                576: { spaceBetween: 16 },
                768: { spaceBetween: 20 },
                1024: { spaceBetween: 28 },
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              loop={true}
            >
              {chunkArray(locationBased, 5)?.map((pageItems, slideIndex) => (
                <SwiperSlide key={slideIndex}>
                  <div className="mt-3 d-flex flex-column gap-2">
                    {pageItems.map((item, i) => (
                      <ProgressBarRow
                        key={`item-${i}`}
                        name={item.name}
                        count={item.count}
                        percent={item.percent}
                        barColor={"#ef4444"}
                        fontPercentage={fontPercentage}
                      />
                    ))}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    );
  };

  const gateBasedWidget = (fontPercentage) => {
    return (
      <div className="col-xl-4 mt-3">
        <div className="bg-white rounded-4 p-3">
          <div className="row">
            <div className="col-10">
              <div className="d-flex align-items-center gap-3">
                <img
                  className="p-2 rounded-circle"
                  src={blueGate}
                  alt="location"
                  style={{ backgroundColor: "#EFF0FF" }}
                />
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(15, fontPercentage)}px`,
                    fontWeight: "700",
                  }}
                >
                  GATE BASED
                </p>
              </div>
            </div>

            <div className="col-2 d-flex justify-content-end">
              <ProgressDots
                paginationCount={paginationCountGate}
                start={startGate}
                end={endGate}
                activeIndex={activeGate}
                autoplayDelay={autoplayDelay}
              />

              {/* Animation keyframes */}
              <style>
                {`
        @keyframes progressFill {
          from { transform: scaleX(0); }
          to { transform: scaleX(1); }
        }
      `}
              </style>
            </div>

            {/* Progress Bars */}
            <Swiper
              onSwiper={(swiper) => (swiperRefGate.current = swiper)}
              spaceBetween={12}
              breakpoints={{
                576: { spaceBetween: 16 },
                768: { spaceBetween: 20 },
                1024: { spaceBetween: 28 },
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              loop={true}
            >
              {chunkArray(gateBased, 5)?.map((pageItems, slideIndex) => (
                <SwiperSlide key={slideIndex}>
                  <div className="mt-3 d-flex flex-column gap-2">
                    {pageItems.map((item, i) => (
                      <ProgressBarRow
                        key={`item-${i}`}
                        name={item.name}
                        count={item.count}
                        percent={item.percent}
                        barColor={"#454CF2"}
                        fontPercentage={fontPercentage}
                      />
                    ))}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    );
  };

  const departmentBasedWidget = (fontPercentage) => {
    return (
      <div className="col-xl-4 mt-3">
        <div className="bg-white rounded-4 p-3">
          <div className="row">
            <div className="col-10">
              <div className="d-flex align-items-center gap-3">
                <img
                  className="p-2 rounded-circle"
                  src={greenDepartment}
                  alt="location"
                  style={{ backgroundColor: "#DFFFE8" }}
                />
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(15, fontPercentage)}px`,
                    fontWeight: "700",
                  }}
                >
                  DEPARTMENT BASED
                </p>
              </div>
            </div>

            <div className="col-2 d-flex justify-content-end">
              <ProgressDots
                paginationCount={paginationCountDepartment}
                start={startDepartment}
                end={endDepartment}
                activeIndex={activeDepartment}
                autoplayDelay={autoplayDelay}
              />
              {/* Animation keyframes */}
              <style>
                {`
        @keyframes progressFill {
          from { transform: scaleX(0); }
          to { transform: scaleX(1); }
        }
      `}
              </style>
            </div>

            {/* Progress Bars */}
            <Swiper
              onSwiper={(swiper) => (swiperRefDepartment.current = swiper)}
              spaceBetween={12}
              breakpoints={{
                576: { spaceBetween: 16 },
                768: { spaceBetween: 20 },
                1024: { spaceBetween: 28 },
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              loop={true}
            >
              {chunkArray(departmentBased, 5).map((pageItems, slideIndex) => (
                <SwiperSlide key={slideIndex}>
                  <div className="mt-3 d-flex flex-column gap-2">
                    {pageItems.map((item, i) => (
                      <ProgressBarRow
                        key={`item-${i}`}
                        name={item.name}
                        count={item.count}
                        percent={item.percent}
                        barColor={"#269144"}
                        fontPercentage={fontPercentage}
                      />
                    ))}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    );
  };

  const organizationBasedWidget = (fontPercentage) => {
    return (
      <div className="col-xl-4 mt-3">
        <div className="bg-white rounded-4 p-3">
          <div className="row">
            <div className="col-10">
              <div className="d-flex align-items-center gap-3">
                <img
                  className="p-2 rounded-circle"
                  src={blueOrg}
                  alt="location"
                  style={{ backgroundColor: "#EDE5FF" }}
                />
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(15, fontPercentage)}px`,
                    fontWeight: "700",
                  }}
                >
                  ORGANIZATION BASED
                </p>
              </div>
            </div>

            <div className="col-2 d-flex justify-content-end">
              <ProgressDots
                paginationCount={paginationCountOrganization}
                start={startOrg}
                end={endOrg}
                activeIndex={activeOrganization}
                autoplayDelay={autoplayDelay}
              />

              {/* Animation keyframes */}
              <style>
                {`
        @keyframes progressFill {
          from { transform: scaleX(0); }
          to { transform: scaleX(1); }
        }
      `}
              </style>
            </div>

            {/* Progress Bars */}
            <Swiper
              onSwiper={(swiper) => (swiperRefOrganization.current = swiper)}
              spaceBetween={12}
              /*  breakpoints={{
                              576: { spaceBetween: 16 },
                              768: { spaceBetween: 20 },
                              1024: { spaceBetween: 28 },
                            }} */
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              loop={true}
            >
              {chunkArray(orgBased, 5)?.map((pageItems, slideIndex) => (
                <SwiperSlide key={slideIndex}>
                  <div className="mt-3 d-flex flex-column gap-2">
                    {pageItems.map((item, i) => (
                      <ProgressBarRow
                        key={`item-${i}`}
                        name={item.name}
                        count={item.count}
                        percent={item.percent}
                        barColor={"#512DA8"}
                        fontPercentage={fontPercentage}
                      />
                    ))}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    );
  };

  const purposeBasedWidget = (fontPercentage) => {
    return (
      <div className="col-xl-4 mt-3">
        <div className="bg-white rounded-4 p-3">
          <div className="row">
            <div className="col-10">
              <div className="d-flex align-items-center gap-3">
                <img
                  className="p-2 rounded-circle"
                  src={greyPurpose}
                  alt="location"
                  style={{ backgroundColor: "#EFEFEF" }}
                />
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(15, fontPercentage)}px`,
                    fontWeight: "700",
                  }}
                >
                  PURPOSE BASED
                </p>
              </div>
            </div>

            <div className="col-2 d-flex justify-content-end">
              <ProgressDots
                paginationCount={paginationCountPurpose}
                start={startPurpose}
                end={endPurpose}
                activeIndex={activePurpose}
                autoplayDelay={autoplayDelay}
              />

              {/* Animation keyframes */}
              <style>
                {`
        @keyframes progressFill {
          from { transform: scaleX(0); }
          to { transform: scaleX(1); }
        }
      `}
              </style>
            </div>

            {/* Progress Bars */}
            <Swiper
              onSwiper={(swiper) => (swiperRefPurpose.current = swiper)}
              spaceBetween={12}
              breakpoints={{
                576: { spaceBetween: 16 },
                768: { spaceBetween: 20 },
                1024: { spaceBetween: 28 },
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              loop={true}
            >
              {chunkArray(purposeBased, 5).map((pageItems, slideIndex) => (
                <SwiperSlide key={slideIndex}>
                  <div className="mt-3 d-flex flex-column gap-2">
                    {pageItems.map((item, i) => (
                      <ProgressBarRow
                        key={`item-${i}`}
                        name={item.name}
                        count={item.count}
                        percent={item.percent}
                        barColor={"#66737E"}
                        fontPercentage={fontPercentage}
                      />
                    ))}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    );
  };
  const meetingPersonBasedWidget = (fontPercentage) => {
    return (
      <div className="col-xl-4 mt-2">
        <div className="bg-white rounded-4 p-3">
          <div className="row">
            <div className="col-10">
              <div className="d-flex align-items-center gap-3">
                <img
                  className="p-2 rounded-circle"
                  src={meetingPerson}
                  alt="location"
                  style={{ backgroundColor: "#FFF3E2" }}
                />
                <p
                  className="m-0"
                  style={{
                    fontSize: `${fontResize(15, fontPercentage)}px`,
                    fontWeight: "700",
                  }}
                >
                  MEETING PERSON BASED
                </p>
              </div>
            </div>

            <div className="col-2 d-flex justify-content-end">
              <ProgressDots
                paginationCount={paginationCountMeetingPerson}
                start={startMeetingPerson}
                end={endMeetingPerson}
                activeIndex={activeMeetingPerson}
                autoplayDelay={autoplayDelay}
              />

              {/* Animation keyframes */}
              <style>
                {`
        @keyframes progressFill {
          from { transform: scaleX(0); }
          to { transform: scaleX(1); }
        }
      `}
              </style>
            </div>

            {/* Progress Bars */}
            <Swiper
              onSwiper={(swiper) => (swiperRefMeetingPerson.current = swiper)}
              spaceBetween={12}
              breakpoints={{
                576: { spaceBetween: 16 },
                768: { spaceBetween: 20 },
                1024: { spaceBetween: 28 },
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              loop={true}
            >
              {chunkArray(meetingPersonBased, 5).map(
                (pageItems, slideIndex) => (
                  <SwiperSlide key={slideIndex}>
                    <div className="mt-3 d-flex flex-column gap-2">
                      {pageItems.map((item, i) => (
                        <ProgressBarRow
                          key={`item-${i}`}
                          name={item.name}
                          count={item.count}
                          percent={item.percent}
                          barColor={"#C57709"}
                          fontPercentage={fontPercentage}
                        />
                      ))}
                    </div>
                  </SwiperSlide>
                )
              )}
            </Swiper>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container
      fluid
      className="main-container"
      style={{
        width: "100vw",
        display: "flex",
        paddingLeft: "0px",
        paddingRight: "0px",
        fontFamily: "Epilogue",
        backgroundColor: "#F6F6F6",
      }}
    >
      <div style={{ width: "100vw" }}>
        <div
          className="mx-1"
          style={{ width: "100vw", display: "flex", flexDirection: "column" }}
        >
          <div style={{ width: "100vw", padding: "16px" }}>
            <div className="dashboard">
              <div className="dashboard-head">
                Visitor dashboard
                <div className="dashboard-content">
                  From the date of{" "}
                  <span>
                    {orgCreateDate} to{" "}
                    {new Date().toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </span>
                </div>
              </div>
            </div>

            <div className="mt-1" style={{ backgroundColor: "#F6F6F6" }}>
              <div>
                {/* <p className="bg-white p-3 ">Visitor dashboard</p> */}
                <div className="row">
                  {sortedWidgetList?.map((widget, i) => {
                    if (!widget.status) return null;

                    const fontPercentage = customFontPercentage(
                      widget.width,
                      widget.width_size
                    );

                    const widgetMap = {
                      "Live Count": liveCountWidget,
                      "History Count": historyCountWidget,
                      "Entry Based": entryBasedWidget,
                      "Registration Based": registrationBasedWidget,
                      "Location Based": locationBasedWidget,
                      "Gate Based": gateBasedWidget,
                      "Department Based": departmentBasedWidget,
                      "Organization Based": organizationBasedWidget,
                      "Purpose Based": purposeBasedWidget,
                      "Meeting Person Based": meetingPersonBasedWidget,
                    };

                    const widgetRenderer = widgetMap[widget.name];
                    return widgetRenderer
                      ? widgetRenderer(fontPercentage)
                      : null;
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default VisitorDashboard;
